<template>
    <header>
        <nav class="bg-white border-gray-200 px-4 lg:px-6 py-2.5 sticky" style="top: 0;">
            <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
                <router-link to="/" class="flex items-center">
                    <img style="height: 7vh;" src="@/assets/icons/quantum-peliculas-logo.svg"
                        class="mr-3 h-6 sm:h-9" alt="Quantum Logo" />
                </router-link>
                <div class="flex items-center lg:order-2">

                    <button @click="mobileMenu = !mobileMenu" data-collapse-toggle="mobile-menu-2" type="button"
                        class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 "
                        aria-controls="mobile-menu-2" aria-expanded="false">
                        <span class="sr-only">Open main menu</span>
                        <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </button>

                </div>

                <div v-bind:class="{ hidden: mobileMenu }"
                    class=" justify-between items-center w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2">
                    <ul class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
                        <li class="item-menu-header">
                            <router-link to="/"
                                class="block py-2 pr-4 pl-3 text-white rounded bg-primary-700 lg:bg-transparent lg:text-primary-700 lg:p-0 "
                                aria-current="page">Home</router-link>
                        </li>
                        <li class="produtos-header">
                            <router-link to="/products"
                                class="item-menu-header produtos-item block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">
                                Produtos
                            </router-link>
                            <ul class="produtos-child">
                                <li>
                                    <router-link to="/peliculas-profissionais">
                                        Películas Profissionais
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/peliculas-nanoceramica">
                                        Películas Nano Cerâmica
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/peliculas-de-seguranca">
                                        Películas de Segurança
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/peliculas-arquitetura-e-decorativa">
                                        Películas Arquitetônicas e Decorativas
                                    </router-link>
                                </li> 
                            </ul>

                        </li>
                        <li class="item-menu-header">
                            <router-link to="/about"
                                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Quem
                                Somos</router-link>
                        </li>

                        <li class="item-menu-header">
                            <router-link to="/questions"
                                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Dúvidas</router-link>
                        </li>
                        <li>
                        </li>
                    </ul>

                </div>
            </div>
        </nav>

        <router-link to="/contato-lojas"
            style="position: fixed; bottom: 3em; right: 3em; background-color: green; padding: 20px 20px; box-sizing: border-box; border-radius: 100em;"
            class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            <i class="fa-brands fa-whatsapp text-4xl"></i>
            <span class="sr-only">Entre em contato</span>
        </router-link>
    </header>

    <router-view />

    <!-- <section id="contato" class="bg-white">
        <div class="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
            <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900">Entre em Contato</h2>
            <p class="mb-8 lg:mb-16 font-light text-center text-gray-500 sm:text-xl">Querendo saber de alguma informação
                que não encontrou em nosso site?</p>
            <form action="#" class="space-y-8">
                <div>
                    <label for="email" class="block mb-2 text-sm font-medium text-gray-900">Seu E-mail</label>
                    <input type="email" id="email"
                        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                        placeholder="seunome@gmail.com" required>
                </div>
                <div>
                    <label for="subject" class="block mb-2 text-sm font-medium text-gray-900">Assunto</label>
                    <input type="text" id="subject"
                        class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500"
                        placeholder="Diga como podemos te ajudar" required>
                </div>
                <div class="sm:col-span-2">
                    <label for="message" class="block mb-2 text-sm font-medium text-gray-900">Sua Mensagem</label>
                    <textarea id="message" rows="6"
                        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500"
                        placeholder="Eu gostaria de saber..."></textarea>
                </div>
                <button type="button"
                    class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100  text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 shadow-lg shadow-blue-500/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">
                    Enviar Mensagem</button>
            </form>
        </div>
    </section> -->

    <footer class="p-4 bg-white sm:p-6">
        <div class="mx-auto max-w-screen-xl">
            <div class="md:flex md:justify-between">
                <div class="mb-6 md:mb-0">
                    <router-link to="/" class="flex items-center">
                        <img style="height: 7vh;" src="@/assets/icons/quantum-peliculas-logo.svg"
                        class="mr-3 h-6 sm:h-9" alt="Quantum Logo" />
                    </router-link>
                </div>
                <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
                    <div>
                        <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase ">Páginas</h2>
                        <ul class="text-gray-600 ">
                            <li class="mb-4">
                                <router-link to="/" class="hover:underline">Início</router-link>
                            </li>
                            <li class="mb-4">
                                <router-link to="/about" class="hover:underline">Quem Somos</router-link>
                            </li>
                            <li class="mb-4">
                                <router-link to="/products" class="hover:underline">Produtos</router-link>
                            </li>
                            <li class="mb-4">
                                <router-link to="/questions" class="hover:underline">Dúvidas</router-link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase ">Redes Sociais</h2>
                        <ul class="text-gray-600 ">
                            <li class="mb-4">
                                <a href="https://www.instagram.com/distribuidoraquantum/" target="_blank"
                                    class="hover:underline ">Instagram</a>
                            </li>
                            <li>
                                <a href="https://www.tiktok.com/@distribuidoraquantum" target="_blank"
                                    class="hover:underline">Tiktok</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase ">Endereços</h2>
                        <ul class="text-gray-600 ">
                            <li class="mb-4">
                                <a href="https://www.google.com/maps/place/Quantum+Distribuidora+-+Venda+Adesivos+Decorativos+e+Automotivos+e+Pel%C3%ADculas+Insufilm+Fum%C3%AA+em+Fortaleza/@-3.7446093,-38.533202,869m/data=!3m3!1e3!4b1!5s0x7c7491d9f58b519:0x9fc33ccdb0e64b7!4m6!3m5!1s0x7c749ffa3136823:0x9bc3210185c42bbe!8m2!3d-3.7446093!4d-38.5283311!16s%2Fg%2F11t622xytg?authuser=0&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D"
                                    target="_blank" class="hover:underline">R. Felino Barroso, 237 - Fátima, Fortaleza -
                                    CE</a>
                            </li>
                            <li class="mb-4">
                                <a href="https://www.google.com/maps/place/QUANTUM+-+Pel%C3%ADculas+e+Adesivos,+adesivos+decorativos,+Acr%C3%ADlico+Placa+de+PVC,+PVC+Expandido,+ACM/@-2.5508861,-44.219979,870m/data=!3m2!1e3!4b1!4m6!3m5!1s0x7f6904296a3ce2b:0xf117461f67a992ae!8m2!3d-2.5508861!4d-44.2174041!16s%2Fg%2F11c7wdrxyn?authuser=0&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D"
                                    target="_blank" class="hover:underline">R. Três, 103 - Forquilha, São Luís - MA</a>
                            </li>
                            <li>
                                <a href="https://www.google.com/maps/place/QUANTUM+-+Pel%C3%ADculas+e+Adesivos,+adesivos+decorativos,+Acr%C3%ADlico+Placa+de+PVC,+PVC+Expandido,+ACM/@-2.5508861,-44.219979,870m/data=!3m2!1e3!4b1!4m6!3m5!1s0x7f6904296a3ce2b:0xf117461f67a992ae!8m2!3d-2.5508861!4d-44.2174041!16s%2Fg%2F11c7wdrxyn?authuser=0&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D"
                                    target="_blank" class="hover:underline">R. Minas Gerais, 510 - Entroncamento, Imperatriz - MA</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr class="my-6 border-gray-200 sm:mx-auto" />
            <div class="flex items-center justify-center">
                <span class="text-sm text-gray-500 text-center">© 2025 <router-link to="/"
                        class="hover:underline">Quantum</router-link>. Todos os direitos reservados.
                </span>
            </div>
            <div class="flex items-center justify-center">
                <span class="text-sm text-gray-500 text-center">Desenvolvido por <a target="_blank"
                        href="https://mscodedesign.com.br/" class="hover:underline">MS Code & Design</a>
                </span>
            </div>
        </div>
    </footer>
</template>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

nav {
    padding: 30px;
}

nav a {
    color: #2c3e50;
}

nav a.router-link-exact-active {
    color: #2c3e50;
    font-weight: bold;
    text-decoration: underline;
}

header {
    position: sticky;
    top: 0;
}

.produtos-child {
    display: none;
}

.produtos-item::after {
    content: '\23F7';
}

.produtos-header:hover .produtos-child {
    display: block;
}

.produtos-header:hover .produtos-item::after {
    content: '\23F6';
    font-weight: bold;
}

.produtos-header li:hover {
    font-weight: bold;
}

.item-menu-header:hover {
    font-weight: bold;
}
</style>

<script>

export default {
    name: 'app',
    data() {
        return {
            mobileMenu: true
        }
    }
}

</script>
